import "./PhaseSelector.css";

import { ChevronRightIcon } from "../../../assets";
import { ProjectPhase } from "../../../constants/project-phase";
import { stringKeyToSentenceCase } from "../../../utils";
import { Button } from "../../forms";

interface PhaseSelectorProps {
  projectPhase: ProjectPhase;
  handlePhaseChange: (phase: ProjectPhase) => void;
  hasHeader?: boolean;
}

export const PhaseSelector = ({
  projectPhase,
  handlePhaseChange,
  hasHeader = true,
}: PhaseSelectorProps): JSX.Element => {
  return (
    <div className="PhaseSelectorContainer">
      {hasHeader && <h3>Select phase</h3>}
      <div className="PhaseButtonsContainer">
        {Object.values(ProjectPhase).map((phase, index) => (
          <div className="PhaseButton" key={phase}>
            {index !== 0 && <ChevronRightIcon />}
            {(phase as ProjectPhase) === projectPhase ? (
              <h3>{stringKeyToSentenceCase(phase)}</h3>
            ) : (
              <Button
                text={stringKeyToSentenceCase(phase)}
                variant="secondary"
                textUnderline
                hasNoPadding
                fontWeight="light"
                size="small"
                onClick={() => handlePhaseChange(phase as ProjectPhase)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
